// extracted by mini-css-extract-plugin
export default {"wrapper":"WeekDays_wrapper__zE+CG","wrapperError":"WeekDays_wrapperError__2hHyC","item":"WeekDays_item__P8Iw0","active":"WeekDays_active__Z9lha"};